import ColorChunk from '/opt/buildhome/repo/.dumi/theme/builtins/ColorChunk/index.tsx';
import API from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/API/index.js';
import Badge from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Badge/index.js';
import CodeGroup from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/CodeGroup/index.js';
import Container from '/opt/buildhome/repo/.dumi/theme/builtins/Container/index.tsx';
import Previewer from '/opt/buildhome/repo/.dumi/theme/builtins/Previewer/index.tsx';
import SourceCode from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/SourceCode/index.js';
import Table from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Table/index.js';
import Tree from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Tree/index.js';
import APITable from '/opt/buildhome/repo/.dumi/theme/builtins/APITable/index.tsx';
import Audio from '/opt/buildhome/repo/.dumi/theme/builtins/Audio/index.tsx';
import ColorPalettes from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPalettes/index.ts';
import ColorPaletteTool from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteTool/index.ts';
import ColorPaletteToolDark from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteToolDark/index.ts';
import ComponentMeta from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentMeta/index.tsx';
import ComponentOverview from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentOverview/index.tsx';
import ComponentTokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentTokenTable/index.tsx';
import DemoWrapper from '/opt/buildhome/repo/.dumi/theme/builtins/DemoWrapper/index.tsx';
import IconSearch from '/opt/buildhome/repo/.dumi/theme/builtins/IconSearch/index.tsx';
import ImagePreview from '/opt/buildhome/repo/.dumi/theme/builtins/ImagePreview/index.tsx';
import InlinePopover from '/opt/buildhome/repo/.dumi/theme/builtins/InlinePopover/index.tsx';
import InstallDependencies from '/opt/buildhome/repo/.dumi/theme/builtins/InstallDependencies/index.tsx';
import LocaleLink from '/opt/buildhome/repo/.dumi/theme/builtins/LocaleLink/index.tsx';
import Palette from '/opt/buildhome/repo/.dumi/theme/builtins/Palette/index.ts';
import ResourceCards from '/opt/buildhome/repo/.dumi/theme/builtins/ResourceCards/index.tsx';
import Sandpack from '/opt/buildhome/repo/.dumi/theme/builtins/Sandpack/index.tsx';
import TokenCompare from '/opt/buildhome/repo/.dumi/theme/builtins/TokenCompare/index.tsx';
import TokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/TokenTable/index.tsx';
import VideoPlayer from '/opt/buildhome/repo/.dumi/theme/builtins/VideoPlayer/index.tsx';
import { DumiDemo } from 'dumi';
import { DumiDemoGrid } from 'dumi';
import { Link } from 'dumi';

import LoadingComponent from '@@/dumi/theme/loading';
import React, { Suspense } from 'react';
import { DumiPage, useTabMeta, useRouteMeta } from 'dumi';

function DumiMarkdownInner() {
  const { texts: $$contentTexts } = useRouteMeta();

  return <><div className="markdown"><p><img src="https://mdn.alipayobjects.com/huamei_iwk9zp/afts/img/A*X2-8QrjSVdEAAAAAAAAAAAAADgCCAQ/fmt.webp" alt="" /></p><p>{$$contentTexts[0].value}<strong>{$$contentTexts[1].value}</strong></p><h2 id="最佳案例"><LocaleLink aria-hidden="true" tabIndex="-1" href="#最佳案例" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"最佳案例"}</h2><p>{$$contentTexts[2].value}</p><p><img src="https://mdn.alipayobjects.com/huamei_iwk9zp/afts/img/A*ko7MS6Ix5EQAAAAAAAAAAAAADgCCAQ/fmt.webp" alt="" /></p></div></>;
}

// export named function for fastRefresh
// ref: https://github.com/pmmmwh/react-refresh-webpack-plugin/blob/main/docs/TROUBLESHOOTING.md#edits-always-lead-to-full-reload
function DumiMarkdownContent() {
  // wrap suspense for catch async meta data
  return <DumiPage><Suspense fallback={<LoadingComponent />}><DumiMarkdownInner /></Suspense></DumiPage>;
}

export default DumiMarkdownContent;